import { useState } from "react";
import { FaChartLine, FaReceipt } from "react-icons/fa6";

import { MyAcquisitionsTab } from "./components/MyAcquisitionsTab";

const financialTabs = [
  {
    key: "acquisitions",
    label: "Minhas Aquisições",
    icon: <FaReceipt />,
    content: <MyAcquisitionsTab />,
  },
  {
    key: "summary",
    label: "Resumo",
    icon: <FaChartLine />,
    content: (
      <div className="border rounded bg-white p-4">
        <div className="fw-semibold">Resumo financeiro</div>
        <small className="text-muted">
          Em breve você poderá acompanhar outros dados financeiros por aqui.
        </small>
      </div>
    ),
  },
] as const;

export function Financial() {
  const [activeTab, setActiveTab] =
    useState<(typeof financialTabs)[number]["key"]>("acquisitions");

  const currentTab = financialTabs.find((tab) => tab.key === activeTab);

  return (
    <section className="bg-light pt-5 pb-4 px-3 overflow-hidden">
      <div className="container px-3 px-md-4 px-lg-0">
        <div className="mb-4">
          <h1 className="h3 fw-bold mb-1">Financeiro</h1>
          <p className="text-muted mb-0">
            Acompanhe suas aquisições e movimentações financeiras.
          </p>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4">
          <ul className="nav nav-pills gap-2" role="tablist">
            {financialTabs.map((tab) => (
              <li className="nav-item" role="presentation" key={tab.key}>
                <button
                  type="button"
                  className={`nav-link d-flex align-items-center gap-2 ${
                    activeTab === tab.key ? "active" : ""
                  }`}
                  role="tab"
                  aria-selected={activeTab === tab.key}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.icon}
                  <span>{tab.label}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>

        {currentTab?.content}
      </div>
    </section>
  );
}
